import { IconButton } from '@mui/material';
import { EditIcon } from '../../../../icons';
import { CellContext } from '@tanstack/react-table';
import { Bonus } from '@pxtra-client-lib-legacy/gen';
import { useGetBonus } from '../../../../../queries/bonus';
import { useCreateBonus } from '../../../../../pages/actions/createBonus/hooks/useCreateBonus';
import { useNavigate } from 'react-router';

export const EditCell = ({ info }: Readonly<{ info: CellContext<Bonus, unknown> }>) => {
  const navigate = useNavigate();
  const { data: bonus } = useGetBonus(info.row.original.id);
  const { newBonus } = useCreateBonus();

  return (
    <IconButton
      onClick={() => {
        try {
          newBonus.loadBonus(bonus ?? info.row.original);
          navigate(`/actions/bonus/edit_bonus/6/${info.row.original.id}`);
        } catch (e) {
          console.error(e);
        }
      }}
      disabled={['CANCELED', 'COMPLETED'].includes(info.row.original.status ?? '')}
    >
      <EditIcon />
    </IconButton>
  );
};
